import { useState } from "react";
import methods from "../../services/utility";
import { Navigate } from "react-router-dom";
import Header from "../header/Header";
import StepProgress from "../../views/public/stepProgress/StepProgress";
import DashboardSidebar from "../sidebar/DashboardSidebar";

const DashboardLayout = ({ component: Component, ...rest }) => {
  const isUserLogedin = methods.checkUserLogin();
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="container-fluid">
      {isUserLogedin ? (
        <>
          <div className="row bg-light">
            <div className="col-lg-2 border-end border-secondary-subtle bg-white">
              <DashboardSidebar />
            </div>
            <div className="col-lg-10 p-4 mx-auto">
              {/* <StepProgress /> */}
              <Component {...rest} />
            </div>
          </div>
        </>
      ) : (
        <Navigate to="/login" />
      )}
    </div>
  );
};

export default DashboardLayout;
